import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { addDepartment, updateDepartment } from 'features/departments/departmentsSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const DepartmentsModal = ({ closeModal, value }: { closeModal: any, value?: IDepartmentsModal }) => {
    const [name, setName] = useState(value?.name || '')
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const resp = await dispatch(value?.id ? updateDepartment({ name, id: value.id }) : addDepartment(name))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    return <Modal black>
        <Flex column between center height='30vh'>
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Department</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Department name' labelText='Name' value={name} onChange={e => setName(e.target.value)} nomarg />
            </Flex>
            <Button disabled={!name} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IDepartmentsModal {
    id?: number
    name: string
}